{
  "title": "Settings",
  "lead": "Game keys for admin builds, and the live link to a game running on this machine.",
  "keys": "Game keys",
  "keysHint": "An admin build reads the tuning with a key: --tuning-url={{site}} --tuning-key=<key> (the Launcher's Admin box sets both). Make one per machine or build; revoke it when it leaves.",
  "label": "Whose is it?",
  "labelHint": "e.g. Julien's Mac, Unity editor",
  "create": "Make a key",
  "secret": "The key, shown this once:",
  "copy": "Copy",
  "copied": "Copied",
  "launch": "Start a build with it",
  "launchHint": "In the Unity editor (or a build started without flags): {{file}} with {\"url\", \"key\"}, or the DELVE_TUNING_URL and DELVE_TUNING_KEY environment variables.",
  "created": "Made",
  "lastUsed": "Last read",
  "never": "never",
  "revoked": "revoked {{at}}",
  "revoke": "Revoke",
  "confirmRevoke": "Revoke {{label}}? Builds using it stop reading the tuning.",
  "noKeys": "No key yet.",
  "live": "Live link",
  "liveHint": "Start the game with --admin (or in the Unity editor), then connect. This page's address must be allowed by the game: localhost and delve-workshop.pages.dev are; add another with --admin-origin=."
}
